import { createNamespacedHelpers } from "vuex";
const { mapState, mapMutations } = createNamespacedHelpers("config");

export default {
  computed: {
    ...mapState(["_preloadedImages"])
  },
  data: function() { return {
    preloadStarted: false,
  } },
  methods: {
    ...mapMutations(["_resetPreloadedImages"]),

    preloadImages() {
      // console.log("preloading: ", this._preloadedImages)
      this.preloadStarted = true
      this._preloadedImages.forEach((src) => {
        this._preloadImage(src)
      });
      this._resetPreloadedImages()
    },
    _preloadImage(src) {
      let img = new Image();
      if (src) {
        img.src = src;
      }
    },
  },
  watch: {
    '$store.state.config._preloadedImages': function() {
      // If preload has already happened, run it again when more images added
      if (this.preloadStarted && this.$store.state.config._preloadedImages.length ) {
        this.preloadImages()
      }
    }
  },
  mounted() {
    this.$nextTick(function () {
      setTimeout(this.preloadImages, 1500);
    });
  },
}